import React from "react";
import { FormControlLabel, Radio, RadioProps } from "@mui/material";
import styles from './rightradiobutton.module.scss'; // added by Bearer Web Developer
import { useThemeMode } from "../../states/contexts/theme";

type IRightRadioButtonProps = RadioProps & {
    label: string;
    gray?: boolean
}
const RightRadioButton: React.FC<IRightRadioButtonProps> = ({ label, value, gray, ...props }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start (create custom radio button)
    return (
        <FormControlLabel
            value={value}
            control={<Radio disableRipple={true} {...props}
                icon={
                    <div className={gray ? styles.icon_gray : styles.icon_blue} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    </div>
                }
                checkedIcon={
                    <div className={gray ? styles.checked_icon_gray : styles.checked_icon_blue} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                        <span></span>
                    </div>
                }
            />}
            label={
                <div className={gray ? styles.label_gray : styles.label_blue} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    {label}
                </div>
            }
        />
    );
    // modified by Bearer Web Developer end
}
export default RightRadioButton;
